
export class Anwser {

	constructor(judoTechnique, isCorrect) {
		this.judoTechnique = judoTechnique;
		this.isCorrect = isCorrect;
	}

}
